import lodashGroupby from 'lodash/groupBy';
import { util } from '@/api/util';
import { contactSearchDbName } from './util/const';
export class ContactDBMark {
    constructor(ctx) {
        this.ctx = ctx;
    }
    async doInsertPersonalMark(options, config = {
        type: 1,
        _lastUpdateTime: Date.now(),
        isIncrease: true,
        noNewMarkData: false,
        quickUpdate: false,
    }) {
        const { list: _data, _account } = options;
        if (!Array.isArray(_data) || !_data.length) {
            return _data;
        }
        const { isIncrease = true, type = 1, quickUpdate = false } = config;
        console.log('[contact_dbl]doInsertPersonalMark', isIncrease, type, quickUpdate);
        const data = _data.map(item => {
            if (item.type === 1) {
                item.originId = item.value;
            }
            else {
                item.value = item.value.includes('personal_org') ? item.value : `personal_org_${item.value}`;
                item.originId = item.value.replace('personal_org_', '');
            }
            return item;
        });
        const personalMarkList = [];
        const ids = [];
        data.forEach(item => {
            ids.push(item.value);
            personalMarkList.push(Object.assign(Object.assign({}, item), { id: util.getUnique(item.value) }));
        });
        const count = await this.ctx.dbApi.putAll({
            dbName: this.ctx.contactUtil.contactDbName,
            tableName: this.ctx.contactUtil.personalMarkTable,
            _dbAccount: _account,
        }, personalMarkList);
        this.ctx.eventApi.sendSysEvent({
            eventName: 'contactPersonalMarkNotify',
            eventStrData: 'notify',
            eventData: {
                actionType: 'update',
                isAll: !isIncrease,
                noNewMarkData: config.noNewMarkData || false,
                data: personalMarkList,
            },
            _account,
        });
        return count;
    }
    async doDeletePersonalMark(params) {
        const { ids, _account } = params;
        if (!Array.isArray(ids) || !ids.length) {
            return 0;
        }
        const data = await this.ctx.dbApi.getByRangeCondition({
            dbName: this.ctx.contactUtil.contactDbName,
            tableName: this.ctx.contactUtil.personalMarkTable,
            adCondition: {
                field: 'value',
                type: 'anyOf',
                args: [ids],
            },
            _dbAccount: _account,
        });
        const idList = [];
        const list = [];
        data.forEach(item => {
            list.push(item);
            idList.push(item.id);
        });
        if (!idList.length) {
            return 0;
        }
        await this.ctx.dbApi.deleteById({
            dbName: this.ctx.contactUtil.contactDbName,
            tableName: this.ctx.contactUtil.personalMarkTable,
            _dbAccount: _account,
        }, idList);
        this.ctx.eventApi.sendSysEvent({
            eventName: 'contactPersonalMarkNotify',
            eventStrData: 'notify',
            eventData: {
                actionType: 'delete',
                isAll: false,
                data: list,
            },
            _account,
        });
        return idList.length;
    }
    async getPersonalMarkListByFields(args, field = 'value', _account) {
        const adCondtionObj = (!Array.isArray(args) || !args.length
            ? {}
            : {
                adCondition: {
                    field,
                    type: 'anyOf',
                    args,
                },
            });
        const rawDataList = (await this.ctx.lokiApi.getByRangeCondition(Object.assign({ dbName: contactSearchDbName, tableName: this.ctx.contactUtil.personalMarkTable, _dbAccount: _account }, adCondtionObj)));
        return this.ctx.contactTrans.transfromPersonalMarkRawData(rawDataList.filter(item => typeof item.marked === 'number' && item.marked > 0));
    }
    async getMaxPersonalMark(_account) {
        var _a;
        const account = _account || ((_a = this.ctx.systemApi.getCurrentUser()) === null || _a === void 0 ? void 0 : _a.id) || '';
        const list = (await this.ctx.lokiApi.getByEqCondition({
            dbName: contactSearchDbName,
            tableName: this.ctx.contactUtil.personalMarkTable,
            _dbAccount: account,
        }));
        const markedList = list.map(item => item.marked);
        markedList.push(0);
        return {
            count: Math.max(...markedList),
            data: this.ctx.contactTrans.transfromPersonalMarkRawData(list.filter(item => typeof item.marked === 'number' && item.marked > 0)),
        };
    }
    async doGetPersonalMarklistByEmail(emails) {
        if (!(emails === null || emails === void 0 ? void 0 : emails.length)) {
            return new Map();
        }
        const modelList = (await this.ctx.lokiApi.getByRangeCondition({
            dbName: contactSearchDbName,
            tableName: this.ctx.contactUtil.personalMarkTable,
            adCondition: {
                type: 'containsAny',
                field: 'emails',
                args: [[...new Set(emails)]],
            },
        }));
        const modelListFlat = modelList && modelList.length
            ? modelList
                .filter(item => typeof item.marked === 'number' && item.marked > 0)
                .map(item => item.emails.map(subEmail => (Object.assign(Object.assign({}, item), { email: subEmail }))))
                .flat()
            : [];
        const markMap = modelListFlat && modelListFlat.length ? lodashGroupby(modelListFlat, item => item.email) : {};
        return new Map(Object.entries(markMap));
    }
    async updatePersonalmarkMailUnreadCount(idMap, _account) {
        const personalMarkList = (await this.ctx.dbApi.getByRangeCondition({
            dbName: this.ctx.contactUtil.contactDbName,
            tableName: this.ctx.contactUtil.personalMarkTable,
            adCondition: {
                type: 'anyOf',
                field: 'id',
                args: [Object.keys(idMap)],
            },
        }, _account));
        return this.ctx.dbApi.putAll({
            dbName: this.ctx.contactUtil.contactDbName,
            tableName: this.ctx.contactUtil.personalMarkTable,
        }, personalMarkList.map(item => (Object.assign(Object.assign({}, item), { unreadMailCount: idMap[item.id] }))), undefined, _account);
    }
    async updateContactOrgMarkInfo(params, sendContactNotify) {
        const { list, type, _account } = params;
        const targetTableName = type === 1 ? this.ctx.contactUtil.contactTable : this.ctx.contactUtil.orgTable;
        const results = await this.ctx.dbApi.putAll({
            dbName: this.ctx.contactUtil.contactDbName,
            tableName: targetTableName,
            _dbAccount: _account,
        }, list);
        type === 1 &&
            sendContactNotify({
                contact_personal: {
                    updateDiff: results.map(item => item.id),
                },
                syncStatus: {
                    personal: !!results.length,
                },
                _account,
            });
        return results;
    }
    async updateContactOrgMarkInfoWithQuery(params, sendContactNotify) {
        const { ids, type, _account } = params;
        const targetTableName = type === 1 ? this.ctx.contactUtil.contactTable : this.ctx.contactUtil.orgTable;
        const idList = [...ids.keys()];
        if (!(idList === null || idList === void 0 ? void 0 : idList.length)) {
            return [];
        }
        const contactList = (await this.ctx.dbApi.getByRangeCondition({
            dbName: this.ctx.contactUtil.contactDbName,
            tableName: targetTableName,
            adCondition: {
                type: 'anyOf',
                field: 'id',
                args: [idList],
            },
            _dbAccount: _account,
        }));
        const results = (await this.ctx.dbApi.putAll({
            dbName: this.ctx.contactUtil.contactDbName,
            tableName: targetTableName,
        }, contactList.map(item => (Object.assign(Object.assign({}, item), { marked: ids.get(item.id).marked })))));
        if (type === 1) {
            sendContactNotify({
                contact_personal: {
                    updateDiff: results.map(item => item.id),
                },
                syncStatus: {
                    personal: !!results.length,
                },
                _account,
            });
        }
        return results;
    }
}
